import ApiService from "@/common/services/http/api.service";

const RegistroImagemService = {
  /**
   * Buscar ScoreCards
   * @param clienteID id do grupo
   * @returns {*}
   */
  async visualizar(registroId) {
    const cliente = JSON.parse(window.localStorage.getItem("cliente"));
    const { data: result } = await ApiService.query(
      `/RegistroImagem/${registroId}/visualizar`,
      { responseType: "blob", params: { clienteID: cliente.id } }
    );

    return result;
  },
};

export default RegistroImagemService;
